import { jsx as _jsx, jsxs as _jsxs } from "preact/jsx-runtime";
import { Back, BackButton, Copy, Heading, Icon, Wrapper, } from './styles';
function QuestionHeader(props) {
    const { title, icon, tag, id, handleBack, showBack, copy, } = props;
    return (_jsxs(Wrapper, { children: [showBack && handleBack && (_jsx(BackButton, { type: "button", onClick: handleBack, children: _jsx(Back, { children: _jsx("use", { xlinkHref: "#icon--chevron-breadcrumbs" }) }) })), icon && (_jsx(Icon, { children: _jsx("use", { xlinkHref: `#icon--${icon}` }) })), tag && (_jsx("span", { className: "tag tag--category", children: tag })), _jsx(Heading, { children: title }), copy && (_jsx(Copy, { children: copy }))] }));
}
QuestionHeader.defaultProps = {
    tag: undefined,
    icon: undefined,
};
export default QuestionHeader;
